<template lang="pug">
.ovg-detail-view
  enviar-poliza-modal(
    v-model="showEnviarPolizaModal"
    :loading="loadingAction"
    :has-error="polizaError"
    @confirm="confirmarEnviarPoliza"
    @cancel="resetPolizaModal"
  )

  //- SILL-1524 — Modal Registrar Pago Manual
  registrar-pago-manual-o-v-g(
    v-if="showPagoManualModal && ovg"
    v-model="showPagoManualModal"
    :ovg="ovg"
    :loading="loadingPagoManual"
    @confirm="confirmarPagoManual"
    @cancel="showPagoManualModal = false"
  )
  //- Loading
  .text-center.p-5(v-if="loading")
    b-spinner(variant="primary")

  template(v-else-if="ovg")
    .container-detail
      //- Header
      .header-ovg.d-none.d-md-flex
        .title-section(@click="$router.push('/garantias-center')")
          b-icon.back-arrow(icon="arrow-left-square-fill")
          h4.title Detalle OVG {{ ovg.id }}
        .actions-section
          b-dropdown.btn-actions(
            v-if="tieneAcciones"
            variant="primary" no-caret right
          )
            template(#button-content)
              .d-flex.align-items-center
                span Acciones
                b-icon.ml-2(icon="chevron-down")
            b-dropdown-item(v-if="ovg.estado === 'solicitado'" @click="showAprobarModal = true") Aprobar
            b-dropdown-item(v-if="ovg.estado === 'solicitado'" @click="showRechazarModal = true") Rechazar
            b-dropdown-item(v-if="ovg.estado === 'aprobado'" @click="showPagoManualModal = true") Registrar Pago Manual
            b-dropdown-item(v-if="ovg.estado === 'comprado'" @click="showEnviarPolizaModal = true") Enviar póliza y cerrar

      .breadcrumbs-ovg
        span.text-muted Inicio / Garantías Extendidas / 
        span.text-dark OVG {{ ovg.id }}

      //- Content
      .content-layout
        //- Panel izquierdo
        .left-panel
          .main-card
            .card-top-header
              span.ovg-id-label OVG {{ ovg.id }}

            //- Estado
            .title-actions-row
              .status-container
                h2.status-title Estado Actual
                b-badge.estado-badge(:variant="estadoVariant(ovg.estado)" pill) {{ estadoLabel(ovg.estado) }}

            //- Cliente
            .detail-section
              .section-subtitle
                b-icon(icon="person-fill")
                span Datos del Cliente
              .data-grid
                .data-item
                  label Nombre
                  p {{ ovg.nombre }} {{ ovg.apellido }}
                .data-item
                  label Correo
                  p {{ ovg.correo }}
                .data-item
                  label RUT
                  p {{ ovg.rut }}
                .data-item
                  label Teléfono
                  p {{ ovg.telefono }}

            //- Equipo
            .detail-section
              .section-subtitle
                b-icon(icon="laptop")
                span Equipo
              .data-grid
                .data-item
                  label N° de Serie
                  p.blue-text {{ ovg.numero_serie }}
                .data-item
                  label Modelo
                  p {{ ovg.modelo }}

            //- Garantía
            .detail-section
              .section-subtitle
                b-icon(icon="shield-check")
                span Garantía
              .data-grid
                .data-item
                  label Plan
                  p {{ ovg.garantia }}
                .data-item
                  label Vencimiento
                  p {{ ovg.fecha_vencimiento || '—' }}
                .data-item(v-if="ovg.codigo_cupon")
                  label Cupón aplicado
                  p.text-success.font-weight-bold {{ ovg.codigo_cupon }}
                .data-item(v-if="ovg.codigo_cupon")
                  label Descuento
                  p.text-success -{{ formatearPeso(ovg.descuento) }}

            //- Protecciones Adicionales
            .detail-section
              .section-subtitle
                b-icon(icon="shield-plus")
                span Protecciones Adicionales
              template(v-if="ovg.protecciones && ovg.protecciones.length")
                .proteccion-row(v-for="p in ovg.protecciones" :key="p.id")
                  span.proteccion-nombre {{ p.nombre }}
                  span.proteccion-precio {{ formatearPeso(p.precio) }}
              span.text-muted(v-else) Sin protección adicional

            //- Resumen de cobro — ticket-32 / cierre crítico SP74
            .detail-section
              .section-subtitle
                b-icon(icon="cash-stack")
                span Resumen de cobro
              .data-grid
                .data-item
                  label Subtotal
                  p {{ formatearPeso(ovg.precio_total) }}
                .data-item(v-if="ovg.codigo_cupon")
                  label Cupón aplicado
                  p.blue-text {{ ovg.codigo_cupon }}
                .data-item(v-if="ovg.descuento > 0")
                  label Descuento
                  p.text-success -{{ formatearPeso(ovg.descuento) }}
                .data-item
                  label Total a pagar
                  p.font-weight-bold {{ formatearPeso(ovg.monto_a_pagar) }}

            //- Boleta
            .detail-section
              .section-subtitle
                b-icon(icon="file-earmark-text-fill")
                span Boleta adjunta
              div
                a.btn.btn-outline-secondary.btn-sm(
                  v-if="ovg.boleta_cliente_url"
                  :href="ovg.boleta_cliente_url"
                  target="_blank"
                )
                  b-icon.mr-1(icon="file-earmark-arrow-down-fill")
                  | Ver / Descargar
                span(v-else) Sin boleta adjunta

        //- Panel derecho — Seguimiento
        .right-panel
          .resumen-card
            .detail-section
              .section-subtitle
                b-icon(icon="clock-history")
                span Seguimiento

              .timeline
                .timeline-item
                  b-icon(icon="circle-fill" :class="'text-secondary'")
                  div
                    p.mb-0
                      strong Solicitud recibida
                    small.text-muted {{ formatDate(ovg.created_at) }}

                .timeline-item(v-if="ovg.aprobado_en")
                  b-icon(icon="circle-fill" class="text-success")
                  div
                    p.mb-0
                      strong Aprobado
                    small.text-muted {{ formatDate(ovg.aprobado_en) }}
                    small.text-muted(v-if="ovg.aprobado_por")  por {{ ovg.aprobado_por }}

                //- SILL-1524: paso de comprado (pago interno o Getnet)
                .timeline-item(v-if="ovg.estado === 'comprado' || ovg.estado === 'cerrada'")
                  b-icon(icon="circle-fill" class="text-primary")
                  div
                    p.mb-0
                      strong Garantía activa
                    small.text-muted Pago registrado — documento tributario generado

                .timeline-item(v-if="ovg.rechazado_en")
                  b-icon(icon="circle-fill" class="text-danger")
                  div
                    p.mb-0
                      strong Rechazado
                    small.text-muted {{ formatDate(ovg.rechazado_en) }}
                    small.text-muted(v-if="ovg.rechazado_por")  por {{ ovg.rechazado_por }}
                    p.motivo-rechazo(v-if="ovg.motivo_rechazo") "{{ ovg.motivo_rechazo }}"

                .timeline-item(v-if="ovg.estado === 'cerrada'")
                  b-icon(icon="circle-fill" class="text-success")
                  div
                    p.mb-0
                      strong OVG cerrada
                    small.text-muted Póliza enviada al cliente

            //- Links de pago
            .detail-section(v-if="ovg.getnet_checkout_url || ovg.getnet_boleta_url")
              .section-subtitle
                b-icon(icon="credit-card")
                span Pago
              div
                a.btn.btn-outline-primary.btn-sm.mb-2.d-block(
                  v-if="ovg.getnet_checkout_url"
                  :href="ovg.getnet_checkout_url"
                  target="_blank"
                )
                  | Link de pago Getnet
                a.btn.btn-outline-secondary.btn-sm.d-block(
                  v-if="ovg.getnet_boleta_url"
                  :href="ovg.getnet_boleta_url"
                  target="_blank"
                )
                  | Boleta Getnet

            //- Link vista previa post-aprobación
            .detail-section(v-if="linkVistaPrevia")
              b-alert(show variant="success")
                p.mb-1
                  strong Garantía aprobada. Correo enviado al cliente.
                p.mb-0 Link vista previa:
                a(:href="linkVistaPrevia" target="_blank") {{ linkVistaPrevia }}

            //- Póliza (estado cerrada) — SILL-1420
            .detail-section(v-if="ovg.estado === 'cerrada'")
              .section-subtitle
                b-icon(icon="file-earmark-check-fill")
                span Póliza
              b-alert(show variant="success" class="mb-2")
                strong OVG cerrada. El cliente recibió el correo con la póliza adjunta.
              div(v-if="ovg.poliza_url")
                a.btn.btn-outline-success.btn-sm(
                  :href="ovg.poliza_url"
                  target="_blank"
                )
                  b-icon.mr-1(icon="file-earmark-arrow-down-fill")
                  | Ver / Descargar póliza

  .not-found(v-else-if="!loading")
    .text-center.p-5
      h4 OVG no encontrada
      b-button(variant="primary" @click="$router.push('/garantias-center')") Volver al listado

  //- Modal Aprobar
  b-modal(
    v-model="showAprobarModal"
    title="Aprobar garantía"
    ok-title="Confirmar aprobación"
    cancel-title="Cancelar"
    ok-variant="success"
    :ok-disabled="loadingAction"
    @ok.prevent="confirmarAprobar"
  )
    p ¿Confirmas que deseas aprobar esta solicitud de garantía extendida?
    p.text-muted.small Se enviará un correo al cliente con el link de pago.

  //- Modal Rechazar
  b-modal(
    v-model="showRechazarModal"
    title="Rechazar garantía"
    ok-title="Confirmar rechazo"
    cancel-title="Cancelar"
    ok-variant="danger"
    :ok-disabled="loadingAction || !motivoRechazo.trim()"
    @ok.prevent="confirmarRechazar"
  )
    b-form-group(label="Motivo del rechazo *")
      b-form-textarea(
        v-model="motivoRechazo"
        placeholder="Describe el motivo del rechazo..."
        rows="3"
      )
    p.text-danger.small(v-if="!motivoRechazo.trim()") El motivo es obligatorio.


</template>

<script>
import { mapActions, mapState } from 'vuex'
import EnviarPolizaModal from '@/components/OVG/EnviarPolizaModal.vue'
import RegistrarPagoManualOVG from '@/components/OVG/RegistrarPagoManualOVG.vue'

export default {
  name: 'OVGDetailView',
  components: { EnviarPolizaModal, RegistrarPagoManualOVG },
  data() {
    return {
      loading: true,
      loadingAction: false,
      showAprobarModal: false,
      showRechazarModal: false,
      motivoRechazo: '',
      // SILL-1458
      showEnviarPolizaModal: false,
      polizaError: false,
      // SILL-1524
      showPagoManualModal: false,
      loadingPagoManual: false,
    }
  },
  computed: {
    ...mapState('OVGCenterStore', ['ovgDetail']),
    ovg() {
      return this.ovgDetail
    },
    tieneAcciones() {
      return (
        this.ovg &&
        ['solicitado', 'aprobado', 'comprado'].includes(this.ovg.estado)
      )
    },
    // Fix 2: derivado del store — visible al cargar OVG ya aprobado
    linkVistaPrevia() {
      return (this.ovgDetail && this.ovgDetail.link_vista_previa) || null
    },
  },
  methods: {
    ...mapActions('OVGCenterStore', [
      'getOvgDetail',
      'aprobarOvg',
      'rechazarOvg',
      'enviarPolizaOvg',
      'registrarPagoInternoOvg',
    ]),

    async fetchData() {
      this.loading = true
      try {
        await this.getOvgDetail(this.$route.params.id)
      } catch (err) {
        this.$bvToast.toast('Error al cargar la garantía', {
          variant: 'danger',
        })
      } finally {
        this.loading = false
      }
    },

    async confirmarAprobar() {
      this.loadingAction = true
      try {
        await this.aprobarOvg(this.ovg.id)
        this.showAprobarModal = false
        this.$bvToast.toast('Garantía aprobada. Correo enviado al cliente.', {
          variant: 'success',
          title: 'Aprobado',
        })
      } catch (err) {
        const status = err.response && err.response.status
        if (status === 409) {
          this.$bvToast.toast('Esta garantía ya estaba aprobada.', {
            variant: 'warning',
          })
        } else if (status === 502) {
          this.$bvToast.toast(
            'Error al generar el link de pago (Getnet falló). Reintenta más tarde.',
            { variant: 'danger', title: 'Error de pago' }
          )
        } else {
          this.$bvToast.toast('Error al aprobar la garantía.', {
            variant: 'danger',
          })
        }
        this.showAprobarModal = false
      } finally {
        this.loadingAction = false
      }
    },

    async confirmarRechazar() {
      if (!this.motivoRechazo.trim()) return
      this.loadingAction = true
      try {
        await this.rechazarOvg({
          id: this.ovg.id,
          motivo: this.motivoRechazo.trim(),
        })
        this.showRechazarModal = false
        this.motivoRechazo = ''
        this.$bvToast.toast('Garantía rechazada.', { variant: 'success' })
      } catch (err) {
        this.$bvToast.toast('Error al rechazar la garantía.', {
          variant: 'danger',
        })
        this.showRechazarModal = false
      } finally {
        this.loadingAction = false
      }
    },

    estadoLabel(estado) {
      const labels = {
        solicitado: 'Solicitado',
        aprobado: 'Aprobado',
        rechazado: 'Rechazado',
        comprado: 'Comprado',
        cerrada: 'Cerrada',
      }
      return labels[estado] || estado
    },

    estadoVariant(estado) {
      const variants = {
        solicitado: 'warning',
        aprobado: 'success',
        rechazado: 'danger',
        comprado: 'primary',
        cerrada: 'secondary',
      }
      return variants[estado] || 'secondary'
    },

    formatDate(val) {
      if (!val) return '—'
      return new Date(val).toLocaleString('es-CL', {
        dateStyle: 'short',
        timeStyle: 'short',
      })
    },

    formatearPeso(valor) {
      const num = parseFloat(valor) || 0
      return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
      }).format(num)
    },

    // SILL-1524
    async confirmarPagoManual({
      tipo_documento,
      rut_contribuyente,
      razon_social_contribuyente,
      codigo_cupon,
      giro,
      direccion_tributaria,
      comuna_tributaria,
    }) {
      this.loadingPagoManual = true
      try {
        await this.registrarPagoInternoOvg({
          id: this.ovg.id,
          tipo_documento,
          rut_contribuyente,
          razon_social_contribuyente,
          codigo_cupon,
          giro,
          direccion_tributaria,
          comuna_tributaria,
        })
        this.showPagoManualModal = false
        this.$bvToast.toast(
          'La garantía está activa y el documento se generó correctamente.',
          { variant: 'success', title: 'Pago registrado con éxito.' }
        )
        await this.getOvgDetail(this.$route.params.id)
      } catch (err) {
        const data = err.response && err.response.data
        const errorCupon = data && data.codigo_cupon
        const msg =
          (Array.isArray(errorCupon) ? errorCupon[0] : errorCupon) ||
          (data && data.error) ||
          'El pago no ha sido registrado. Por favor, inténtalo de nuevo.'
        this.$bvToast.toast(msg, {
          variant: 'danger',
          title: 'No pudimos generar el documento tributario.',
        })
      } finally {
        this.loadingPagoManual = false
      }
    },

    // SILL-1458
    resetPolizaModal() {
      this.showEnviarPolizaModal = false
      this.polizaError = false
    },

    async confirmarEnviarPoliza(polizaFile) {
      this.loadingAction = true
      try {
        await this.enviarPolizaOvg({ id: this.ovg.id, poliza: polizaFile })
        this.showEnviarPolizaModal = false
        this.polizaError = false
        this.$bvToast.toast(
          'Póliza enviada. El cliente recibió el correo de confirmación.',
          {
            variant: 'success',
            title: 'OVG cerrada',
          }
        )
      } catch {
        this.polizaError = true
      } finally {
        this.loadingAction = false
      }
    },
  },
  mounted() {
    this.fetchData()
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/colors.scss';

.ovg-detail-view {
  background-color: #f5f6fa;
  min-height: 100vh;
  padding-bottom: 50px;
}

.container-detail {
  padding: 20px;
}

.header-ovg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 4rem;

  .title-section {
    display: flex;
    align-items: center;
    gap: 15px;
    cursor: pointer;

    .back-arrow {
      color: $samtek-yellow;
      font-size: 32px;
    }

    .title {
      margin: 0;
      font-weight: bold;
      color: $samtek-black;
    }
  }

  .actions-section {
    .btn-actions {
      ::v-deep .btn {
        background-color: $samtek-yellow;
        border: none;
        color: $samtek-black;
        border-radius: 8px;
        height: 40px;
        font-weight: 500;
        padding: 0 15px;

        &:hover {
          background-color: darken($samtek-yellow, 5%);
        }
      }
    }
  }
}

.breadcrumbs-ovg {
  margin-bottom: 25px;
  font-size: 14px;
}

.content-layout {
  display: flex;
  gap: 20px;
  align-items: flex-start;
}

.left-panel {
  flex: 1;
  min-width: 0;
}

.right-panel {
  width: 360px;
  flex-shrink: 0;
}

.main-card,
.resumen-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.05);
}

.card-top-header {
  margin-bottom: 16px;

  .ovg-id-label {
    font-weight: 700;
    font-size: 15px;
    color: #525252;
  }
}

.title-actions-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 24px;

  .status-container {
    display: flex;
    align-items: center;
    gap: 20px;

    .status-title {
      font-weight: 700;
      font-size: 25px;
      color: #23201c;
      margin: 0;
    }

    .estado-badge {
      font-size: 14px;
      padding: 6px 14px;
    }
  }
}

.detail-section {
  margin-bottom: 28px;

  .section-subtitle {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 16px;

    .b-icon {
      font-size: 20px;
      color: #23201c;
    }

    span {
      font-weight: 700;
      font-size: 18px;
      color: #23201c;
    }
  }
}

.data-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.data-item {
  label {
    display: block;
    font-weight: 700;
    font-size: 13px;
    color: #525252;
    margin-bottom: 2px;
  }

  p {
    font-size: 14px;
    color: #525252;
    margin: 0;

    &.blue-text {
      color: #1d4ed8;
      font-weight: 700;
    }
  }
}

.proteccion-row {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.proteccion-nombre {
  font-size: 14px;
  color: #525252;
}

.proteccion-precio {
  font-size: 14px;
  font-weight: 700;
  color: #23201c;
}

.timeline {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .timeline-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;

    .b-icon {
      margin-top: 3px;
      font-size: 12px;
      flex-shrink: 0;
    }
  }
}

.motivo-rechazo {
  font-style: italic;
  color: #dc3545;
  font-size: 13px;
  margin-top: 4px;
}

@media (max-width: 1024px) {
  .content-layout {
    flex-direction: column;
  }

  .right-panel {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .data-grid {
    grid-template-columns: 1fr;
  }
}
</style>
